import './BadgeMovie.scss'

const tagsStyle = {
    A: 'A-tag-style',
    V: 'V-tag-style',
    O: 'O-tag-style',
    Z: 'Z-tag-style',
    H: 'H-tag-style',
}

export default function BadgeMovie({ badge }) {
    return <span className={`badge-movie ${tagsStyle[badge.type]}`}>{badge.name}</span>
}
